/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
  useReducer,
  useImperativeHandle,
  forwardRef,
} from "react";
import { CircularProgress, Menu, MenuItem, Tooltip } from "@mui/material";
import { IoIosRefresh } from "react-icons/io";
import { BsThreeDotsVertical, BsCloudFog2 } from "react-icons/bs";
import { MdApartment } from "react-icons/md";
import {
  IoPersonOutline,
  IoFlagOutline,
  IoCopyOutline,
  IoCheckmark,
} from "react-icons/io5";
import { FiShare2, FiMail } from "react-icons/fi";
import { RiBuilding2Fill } from "react-icons/ri";
import { LiaTagSolid } from "react-icons/lia";
import { toast } from "react-toastify";
import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "store/ducks/auth/types";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";
import { useGetEtapas } from "services/api/Etapas_Subetapas/etapas-get";
import { getEtiquetas } from "services/api/AppWeb_Lead/listar-etiquetas";
import { postEtiquetaLead } from "services/api/AppWeb_Lead/alterar-etiqueta-lead";
import DialogCommon from "components/dialogCommon";
import { EtapasModal } from "components/dialogCommon/templates/etapasModal";
import { ProdutosModal } from "components/dialogCommon/templates/produtosModal";
import AtualizarLeadModal from "components/AtualizarLeadModal";
import { Lead } from "interfaces";
import color from "constants/color";
import { buildFiltersBody } from "../../utils/buildFiltersBody";
import { FAROL_COLORS, DEFAULT_FAROL_COLORS } from "../tableGrid/constants";
import * as S from "./styles";

const PAGE_SIZE = 8;

const formatCreatedDate = (value?: string | null): string => {
  if (!value) return "";
  const datePart = String(value).split(" ")[0];
  const [y, m, d] = datePart.includes("-") ? datePart.split("-") : ["", "", ""];
  if (y && m && d) return `${d}/${m}/${y}`;
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "";
  const dd = String(parsed.getDate()).padStart(2, "0");
  const mm = String(parsed.getMonth() + 1).padStart(2, "0");
  return `${dd}/${mm}/${parsed.getFullYear()}`;
};

interface KanbanViewProps {
  filters: any;
  isShared: boolean;
  requestLeads: Function;
  onMenuClick: (
    e: React.MouseEvent,
    idLead: string,
    idLeadCorretor: string,
    nomeLead: string
  ) => void;
  onWhatsAppClick?: (lead: Lead) => void;
  onWhatsAppCopyPhone?: (lead: Lead) => void;
  isWhatsConnected?: boolean;
  getWhatsAppUnreadCount?: (lead: Lead) => number;
}

interface EtapaOption {
  id: string;
  nome: string;
}

// ── Per-column state ───────────────────────────────────────────────────────────
interface ColState {
  leads: Lead[];
  page: number;
  hasMore: boolean;
  loading: boolean;
}

type ColAction =
  | { type: "FETCH_START" }
  | { type: "FETCH_SUCCESS"; leads: Lead[]; page: number; hasMore: boolean }
  | { type: "RESET" }
  | { type: "PATCH_LEAD"; idLeadCorretor: string; patch: Partial<Lead> };

function colReducer(state: ColState, action: ColAction): ColState {
  switch (action.type) {
    case "FETCH_START":
      return { ...state, loading: true };
    case "FETCH_SUCCESS":
      return {
        leads:
          action.page === 1 ? action.leads : [...state.leads, ...action.leads],
        page: action.page,
        hasMore: action.hasMore,
        loading: false,
      };
    case "RESET":
      return { leads: [], page: 0, hasMore: true, loading: false };
    case "PATCH_LEAD":
      return {
        ...state,
        leads: state.leads.map((l) =>
          l.idLeadCorretor === action.idLeadCorretor
            ? { ...l, ...action.patch }
            : l
        ),
      };
    default:
      return state;
  }
}

// ── Helpers ────────────────────────────────────────────────────────────────────
const getFarolColors = (farol: string, type: "background" | "text"): string => {
  const c = FAROL_COLORS[farol] || DEFAULT_FAROL_COLORS;
  return c[type];
};

const formatPhone = (phone: string | null | undefined): string => {
  if (!phone) return "--";
  const digits = phone.replace(/\D/g, "");
  if (digits.length === 13)
    return `+${digits.slice(0, 2)} (${digits.slice(2, 4)}) ${digits.slice(
      4,
      9
    )}-${digits.slice(9)}`;
  if (digits.length === 11)
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
  if (digits.length === 10)
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  return phone;
};

const EtapaIcon = () => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#D1FADF",
      border: "8px solid #ECFDF3",
      padding: 2,
      borderRadius: "50%",
      height: 52,
      width: 52,
      marginRight: 12,
    }}
  >
    <IoIosRefresh color="black" size={24} style={{ margin: 0 }} />
  </div>
);

// ── KanbanCard ─────────────────────────────────────────────────────────────────
interface CardProps {
  lead: Lead;
  isDragging: boolean;
  isShared: boolean;
  readOnly?: boolean;
  onDragStart: (e: React.DragEvent) => void;
  onDragEnd: () => void;
  onUpdateClick: (lead: Lead) => void;
  onProdutoClick: (lead: Lead) => void;
  onEtiquetaClick: (e: React.MouseEvent, lead: Lead) => void;
  onSubEtapaClick: (lead: Lead) => void;
  showCorretorEquipe?: boolean;
  cargoExibicao?: "super" | "gerente" | null;
  onMenuClick: (
    e: React.MouseEvent,
    idLead: string,
    idLeadCorretor: string,
    nomeLead: string
  ) => void;
  onWhatsAppClick: (lead: Lead) => void;
  onWhatsAppCopyPhone?: (lead: Lead) => void;
  isWhatsConnected?: boolean;
  whatsAppUnreadCount?: number;
}

// Mascara telefone: (11) 9****-6458
const maskPhone = (phone: string): string => {
  const formatted = formatPhone(phone);
  // Substitui os dígitos do meio por ****
  return formatted.replace(/(\(\d{2}\)\s?\d?)(\d+)(-\d{4})$/, "$1****$3");
};

// Mascara email: f***@gmail.com
const maskEmail = (email: string): string => {
  const at = email.indexOf("@");
  if (at <= 1) return email;
  return `${email[0]}***${email.slice(at)}`;
};

const KanbanCard = React.memo(
  ({
    lead,
    isDragging,
    isShared,
    readOnly = false,
    onDragStart,
    onDragEnd,
    onUpdateClick,
    onProdutoClick,
    onSubEtapaClick,
    showCorretorEquipe,
    cargoExibicao,
    onEtiquetaClick,
    onMenuClick,
    onWhatsAppClick,
    onWhatsAppCopyPhone,
    isWhatsConnected = false,
    whatsAppUnreadCount = 0,
  }: CardProps) => {
    const phones = [lead.telefone1, lead.telefone2, lead.telefone3];
    const phonePrincipal =
      phones[(lead.codigoTelefonePrincipal || 1) - 1] || lead.telefone1;
    const emails = [lead.email1, lead.email2, lead.email3];
    const emailPrincipal =
      emails[(lead.codigoEmailPrincipal || 1) - 1] || lead.email1;
    const farolBg = getFarolColors(lead.farolAtualizacao, "background");
    const farolText = getFarolColors(lead.farolAtualizacao, "text");
    const tempLower = (lead.temperaturaLead || "").toLowerCase();
    const [copiedField, setCopiedField] = useState<string | null>(null);
    const [isLeadPhotoBroken, setIsLeadPhotoBroken] = useState(false);
    const emps: Array<{ id: string; nome: string }> = Array.isArray(
      lead.empreendimentos
    )
      ? lead.empreendimentos
      : [];
    const empFirst = emps[0]?.nome || null;
    const empLabel = empFirst
      ? `${empFirst}${emps.length > 1 ? ` +${emps.length - 1}` : ""}`
      : "Sem produto";
    const leadInitial = (lead.nome || "?").trim().charAt(0).toUpperCase();
    const unreadLabel = whatsAppUnreadCount > 99 ? "99+" : whatsAppUnreadCount;

    useEffect(() => {
      setIsLeadPhotoBroken(false);
    }, [lead.fotoUrl]);

    const handleCopy = (e: React.MouseEvent, text: string, field: string) => {
      e.preventDefault();
      e.stopPropagation();
      navigator.clipboard?.writeText(text);
      setCopiedField(field);
      setTimeout(() => setCopiedField(null), 2000);
    };

    // Distingue clique simples de drag
    const mouseDownPos = useRef<{ x: number; y: number } | null>(null);

    return (
      <S.Card
        draggable={!readOnly}
        isDragging={isDragging}
        onMouseDown={(e) => {
          mouseDownPos.current = { x: e.clientX, y: e.clientY };
        }}
        onClick={(e) => {
          if (mouseDownPos.current) {
            const dx = Math.abs(e.clientX - mouseDownPos.current.x);
            const dy = Math.abs(e.clientY - mouseDownPos.current.y);
            if (dx > 5 || dy > 5) return;
          }
          window.location.href = `/lead-detail/${lead.idLeadCorretor}`;
        }}
        onDragStart={readOnly ? undefined : onDragStart}
        onDragEnd={readOnly ? undefined : onDragEnd}
      >
        {/* Farol — faixa colorida no topo */}
        {lead.mensagemFarolAtualizacao && (
          <S.CardFarol bg={farolBg} textColor={farolText}>
            <IoIosRefresh size={13} style={{ flexShrink: 0 }} />
            <span
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {lead.mensagemFarolAtualizacao}
            </span>
          </S.CardFarol>
        )}

        <S.CardBody>
          {/* Linha 1: menu ⋮ + nome + código */}
          <S.CardTopRow>
            {!readOnly && (
              <Tooltip title="Outras ações" placement="top" arrow>
                <S.CardMenuBtn
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    onMenuClick(e, lead.idLead, lead.idLeadCorretor, lead.nome);
                  }}
                >
                  <BsThreeDotsVertical size={15} />
                </S.CardMenuBtn>
              </Tooltip>
            )}
            {lead.fotoUrl && !isLeadPhotoBroken ? (
              <S.CardLeadAvatar
                src={lead.fotoUrl}
                alt={lead.nome}
                onError={() => setIsLeadPhotoBroken(true)}
              />
            ) : (
              <S.CardLeadAvatarFallback>
                {leadInitial || "?"}
              </S.CardLeadAvatarFallback>
            )}
            <Tooltip title={lead.nome} placement="top" arrow>
              <S.CardName>{lead.nome}</S.CardName>
            </Tooltip>
            {lead.codigoLeadCrm2013 && (
              <Tooltip
                title={
                  copiedField === "codigo"
                    ? "Copiado!"
                    : "Copiar código do lead"
                }
                placement="top"
                arrow
              >
                <S.CardCodigo
                  as="button"
                  type="button"
                  onClick={(e) =>
                    handleCopy(e, String(lead.codigoLeadCrm2013), "codigo")
                  }
                >
                  {lead.codigoLeadCrm2013}
                </S.CardCodigo>
              </Tooltip>
            )}
          </S.CardTopRow>

          {/* Linha 2: telefone + copiar + etiqueta clicável */}
          <S.CardPhoneRow>
            <S.CardPhoneGroup>
              {phonePrincipal ? (
                <>
                  <S.CardPhoneLink as="div">
                    <Tooltip
                      title={
                        isWhatsConnected
                          ? "Abrir conversa do WhatsApp"
                          : "Abrir no WhatsApp"
                      }
                      placement="top"
                      arrow
                    >
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          onWhatsAppClick(lead);
                        }}
                        style={{
                          background: "none",
                          border: "none",
                          padding: 0,
                          cursor: "pointer",
                          display: "inline-flex",
                          alignItems: "center",
                        }}
                        aria-label="Abrir conversa do WhatsApp"
                      >
                        <S.CardWhatsAppIconWrap>
                          <i
                            style={{
                              backgroundColor: color.Success,
                              borderRadius: "50%",
                              color: "white",
                              width: 22,
                              height: 22,
                              fontSize: 15,
                              lineHeight: 1,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexShrink: 0,
                            }}
                            className="lab la-whatsapp"
                          />
                          {whatsAppUnreadCount > 0 && (
                            <S.CardWhatsAppUnreadBadge>
                              {unreadLabel}
                            </S.CardWhatsAppUnreadBadge>
                          )}
                        </S.CardWhatsAppIconWrap>
                      </button>
                    </Tooltip>
                    <Tooltip
                      title={`${formatPhone(phonePrincipal)} · Copiar`}
                      placement="top"
                      arrow
                    >
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (onWhatsAppCopyPhone) {
                            onWhatsAppCopyPhone(lead);
                          } else {
                            handleCopy(e, formatPhone(phonePrincipal), "phone");
                          }
                        }}
                        style={{
                          background: "none",
                          border: "none",
                          padding: 0,
                          cursor: "pointer",
                          display: "inline-flex",
                          alignItems: "center",
                          color: "inherit",
                          font: "inherit",
                          whiteSpace: "nowrap",
                        }}
                        aria-label="Copiar número"
                      >
                        <S.CardPhoneText>
                          {maskPhone(phonePrincipal)}
                        </S.CardPhoneText>
                      </button>
                    </Tooltip>
                  </S.CardPhoneLink>
                  <Tooltip
                    title={
                      copiedField === "phone" ? "Copiado!" : "Copiar telefone"
                    }
                    placement="top"
                    arrow
                  >
                    <S.CopyBtn
                      type="button"
                      onClick={(e) =>
                        handleCopy(e, formatPhone(phonePrincipal), "phone")
                      }
                    >
                      {copiedField === "phone" ? (
                        <IoCheckmark size={14} color="#22c55e" />
                      ) : (
                        <IoCopyOutline size={14} />
                      )}
                    </S.CopyBtn>
                  </Tooltip>
                </>
              ) : (
                <S.CardPhoneNoData>Sem telefone</S.CardPhoneNoData>
              )}
            </S.CardPhoneGroup>

            {/* Etiqueta — sempre visível; clique abre menu ou avisa se compartilhado.
                Gerente online (readOnly): só visualiza a etiqueta existente, sem
                ação de alterar nem placeholder de adicionar. */}
            {lead.etiqueta ? (
              <Tooltip
                title={
                  readOnly
                    ? lead.etiqueta.nome
                    : isShared
                    ? "Exclusivo para o dono do lead"
                    : `${lead.etiqueta.nome} — clique para alterar`
                }
                placement="top"
                arrow
              >
                <S.CardEtiqueta
                  cor={lead.etiqueta.cor}
                  style={readOnly ? { cursor: "default" } : undefined}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (readOnly) return;
                    if (isShared) {
                      toast.warning("Exclusivo para o dono do lead");
                      return;
                    }
                    onEtiquetaClick(e, lead);
                  }}
                >
                  {lead.etiqueta.nome}
                </S.CardEtiqueta>
              </Tooltip>
            ) : (
              !readOnly && (
                <Tooltip
                  title={
                    isShared
                      ? "Exclusivo para o dono do lead"
                      : "Adicionar etiqueta"
                  }
                  placement="top"
                  arrow
                >
                  <S.CardEtiquetaEmpty
                    onClick={(e) => {
                      e.stopPropagation();
                      if (isShared) {
                        toast.warning("Exclusivo para o dono do lead");
                        return;
                      }
                      onEtiquetaClick(e, lead);
                    }}
                  >
                    <LiaTagSolid size={12} style={{ marginRight: 2 }} />
                    Etiqueta
                  </S.CardEtiquetaEmpty>
                </Tooltip>
              )
            )}
          </S.CardPhoneRow>

          {/* Linha 3: email (esq.) + Atualizar Lead (dir.) — sempre visível */}
          <S.CardEmailRow>
            <S.CardEmailGroup>
              <FiMail size={16} color="#2d5bff" style={{ flexShrink: 0 }} />
              {emailPrincipal ? (
                <>
                  <Tooltip title={emailPrincipal} placement="top" arrow>
                    <S.CardEmailText>
                      {maskEmail(emailPrincipal)}
                    </S.CardEmailText>
                  </Tooltip>
                  <Tooltip
                    title={
                      copiedField === "email" ? "Copiado!" : "Copiar e-mail"
                    }
                    placement="top"
                    arrow
                  >
                    <S.CopyBtn
                      type="button"
                      onClick={(e) => handleCopy(e, emailPrincipal, "email")}
                    >
                      {copiedField === "email" ? (
                        <IoCheckmark size={14} color="#22c55e" />
                      ) : (
                        <IoCopyOutline size={14} />
                      )}
                    </S.CopyBtn>
                  </Tooltip>
                </>
              ) : (
                <S.CardNoData>Sem e-mail</S.CardNoData>
              )}
            </S.CardEmailGroup>
            {!readOnly && (
              <S.CardUpdateBtn
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  onUpdateClick(lead);
                }}
              >
                Atualizar Lead
              </S.CardUpdateBtn>
            )}
          </S.CardEmailRow>

          {/* Linha 4: empreendimento — clicável, hover azul, abre ProdutosModal.
              Gerente online (readOnly): apenas exibe os produtos, sem alterar. */}
          <Tooltip
            title={readOnly ? empLabel : "Clique para alterar produtos"}
            placement="top"
            arrow
          >
            <S.CardClickableRow
              style={readOnly ? { cursor: "default" } : undefined}
              onClick={(e) => {
                e.stopPropagation();
                if (readOnly) return;
                onProdutoClick(lead);
              }}
            >
              <MdApartment
                size={17}
                color="#2d5bff"
                style={{ flexShrink: 0 }}
              />
              <S.CardClickableText>{empLabel}</S.CardClickableText>
            </S.CardClickableRow>
          </Tooltip>

          {/* Linha 5: sub-etapa — clicável (abre EtapasModal).
              Gerente online (readOnly): apenas exibe a subetapa, sem alterar. */}
          {lead.subEtapaFunil ? (
            <Tooltip
              title={
                readOnly ? lead.subEtapaFunil : "Clique para alterar subetapa"
              }
              placement="top"
              arrow
            >
              <S.CardSubEtapa
                onClick={(e) => {
                  e.stopPropagation();
                  if (readOnly) return;
                  onSubEtapaClick(lead);
                }}
                style={{ cursor: readOnly ? "default" : "pointer" }}
              >
                <IoFlagOutline size={13} style={{ flexShrink: 0 }} />
                <span>{lead.subEtapaFunil}</span>
              </S.CardSubEtapa>
            </Tooltip>
          ) : (
            <Tooltip
              title={readOnly ? "Sem subetapa" : "Clique para definir subetapa"}
              placement="top"
              arrow
            >
              <S.CardSubEtapaEmpty
                onClick={(e) => {
                  e.stopPropagation();
                  if (readOnly) return;
                  onSubEtapaClick(lead);
                }}
                style={{ cursor: readOnly ? "default" : "pointer" }}
              >
                <IoFlagOutline size={13} style={{ flexShrink: 0 }} />
                <span>Sem subetapa</span>
              </S.CardSubEtapaEmpty>
            </Tooltip>
          )}

          {/* Corretor responsável + Equipe/Último responsável (visível para gestores) */}
          {showCorretorEquipe && (
            <S.CardCorretorEquipeRow>
              {lead.nomeCorretorLead && (
                <S.CardCorretorEquipeItem>
                  <S.CardCorretorEquipeLabel>
                    Corretor responsável
                  </S.CardCorretorEquipeLabel>
                  <S.CardCorretorEquipeValue>
                    {lead.urlFotoUsuarioCorretorLead ? (
                      <S.CardSharedAvatar
                        src={lead.urlFotoUsuarioCorretorLead}
                        alt={lead.nomeCorretorLead}
                      />
                    ) : (
                      <S.CardSharedAvatarFallback>
                        {lead.nomeCorretorLead.charAt(0).toUpperCase()}
                      </S.CardSharedAvatarFallback>
                    )}
                    <Tooltip
                      title={lead.nomeCorretorLead}
                      placement="top"
                      arrow
                    >
                      <S.CardSharedName>
                        {lead.nomeCorretorLead}
                      </S.CardSharedName>
                    </Tooltip>
                  </S.CardCorretorEquipeValue>
                </S.CardCorretorEquipeItem>
              )}
              {cargoExibicao === "super" && lead.equipe && (
                <S.CardCorretorEquipeItem>
                  <S.CardCorretorEquipeLabel>Equipe</S.CardCorretorEquipeLabel>
                  <S.CardCorretorEquipeValue>
                    {lead.urlFotoUsuarioLiderEquipe ? (
                      <S.CardSharedAvatar
                        src={lead.urlFotoUsuarioLiderEquipe}
                        alt={lead.equipe}
                      />
                    ) : (
                      <S.CardSharedAvatarFallback>
                        {lead.equipe.charAt(0).toUpperCase()}
                      </S.CardSharedAvatarFallback>
                    )}
                    <Tooltip title={lead.equipe} placement="top" arrow>
                      <S.CardSharedName>{lead.equipe}</S.CardSharedName>
                    </Tooltip>
                  </S.CardCorretorEquipeValue>
                </S.CardCorretorEquipeItem>
              )}
              {cargoExibicao === "gerente" && lead.nomeCorretorOrigem && (
                <S.CardCorretorEquipeItem>
                  <S.CardCorretorEquipeLabel>
                    Último responsável
                  </S.CardCorretorEquipeLabel>
                  <S.CardCorretorEquipeValue>
                    {lead.urlFotoUsuarioCorretorOrigemLead ? (
                      <S.CardSharedAvatar
                        src={lead.urlFotoUsuarioCorretorOrigemLead}
                        alt={lead.nomeCorretorOrigem}
                      />
                    ) : (
                      <S.CardSharedAvatarFallback>
                        {lead.nomeCorretorOrigem.charAt(0).toUpperCase()}
                      </S.CardSharedAvatarFallback>
                    )}
                    <Tooltip
                      title={lead.nomeCorretorOrigem}
                      placement="top"
                      arrow
                    >
                      <S.CardSharedName>
                        {lead.nomeCorretorOrigem}
                      </S.CardSharedName>
                    </Tooltip>
                  </S.CardCorretorEquipeValue>
                </S.CardCorretorEquipeItem>
              )}
            </S.CardCorretorEquipeRow>
          )}

          <S.CardDivider />

          {/* Rodapé: badges (cliente, compart.) + temperatura */}
          <S.CardBottom>
            <S.CardBottomLeft>
              {lead.dataCriacao && (
                <Tooltip title="Data de criação do lead" placement="top" arrow>
                  <S.CardCreatedAt>
                    Criado em {formatCreatedDate(lead.dataCriacao)}
                  </S.CardCreatedAt>
                </Tooltip>
              )}
              {lead.identificaCliente && (
                <Tooltip title="Já é cliente" placement="top" arrow>
                  <S.CardBadge>
                    <IoPersonOutline size={13} color="#2d5bff" />
                    <span>Já é cliente</span>
                  </S.CardBadge>
                </Tooltip>
              )}
              {lead.possuiCompartilhamento && (
                <Tooltip title="Lead compartilhado" placement="top" arrow>
                  <S.CardBadge>
                    <FiShare2 size={12} color="#666" />
                    <span>Compart.</span>
                  </S.CardBadge>
                </Tooltip>
              )}
            </S.CardBottomLeft>

            <S.CardTemperatura temp={lead.temperaturaLead}>
              <BsCloudFog2
                size={12}
                color={
                  tempLower === "quente"
                    ? "#D93025"
                    : tempLower === "morno"
                    ? "#C96A00"
                    : tempLower === "frio"
                    ? "#1565C0"
                    : "#888"
                }
              />
              {lead.temperaturaLead || "—"}
            </S.CardTemperatura>
          </S.CardBottom>

          {isShared && lead.nomeCorretorOrigem && (
            <Tooltip
              title={`Compartilhado por: ${lead.nomeCorretorOrigem}`}
              placement="top"
              arrow
            >
              <S.CardSharedBy>
                {lead.urlFotoUsuarioCorretorOrigemLead ? (
                  <S.CardSharedAvatar
                    src={lead.urlFotoUsuarioCorretorOrigemLead}
                    alt={lead.nomeCorretorOrigem}
                  />
                ) : (
                  <S.CardSharedAvatarFallback>
                    {lead.nomeCorretorOrigem.charAt(0).toUpperCase()}
                  </S.CardSharedAvatarFallback>
                )}
                <span>por</span>
                <S.CardSharedName>{lead.nomeCorretorOrigem}</S.CardSharedName>
              </S.CardSharedBy>
            </Tooltip>
          )}
        </S.CardBody>
      </S.Card>
    );
  }
);
KanbanCard.displayName = "KanbanCard";

// ── KanbanColumn — manages its own leads + infinite scroll ─────────────────────
export interface KanbanColumnHandle {
  refresh: () => void;
  patchLead: (idLeadCorretor: string, patch: Partial<Lead>) => void;
}

interface KanbanColumnProps {
  etapa: EtapaOption;
  filters: any;
  isShared: boolean;
  readOnly?: boolean;
  isDragOver: boolean;
  isValidTarget: boolean;
  draggingLeadId: string | null;
  onDragOver: (e: React.DragEvent) => void;
  onDragLeave: (e: React.DragEvent) => void;
  onDrop: (e: React.DragEvent) => void;
  onDragStart: (e: React.DragEvent, lead: Lead) => void;
  onDragEnd: () => void;
  onUpdateClick: (lead: Lead) => void;
  onProdutoClick: (lead: Lead) => void;
  onSubEtapaClick: (lead: Lead) => void;
  showCorretorEquipe?: boolean;
  cargoExibicao?: "super" | "gerente" | null;
  onEtiquetaClick: (e: React.MouseEvent, lead: Lead) => void;
  onMenuClick: (
    e: React.MouseEvent,
    idLead: string,
    idLeadCorretor: string,
    nomeLead: string
  ) => void;
  onWhatsAppClick: (lead: Lead) => void;
  onWhatsAppCopyPhone?: (lead: Lead) => void;
  isWhatsConnected?: boolean;
  getWhatsAppUnreadCount?: (lead: Lead) => number;
  // Notify parent of total count for the column header
  onTotalCount?: (etapaId: string, total: number) => void;
  // Trigger reset when filters change
  filtersKey: string;
}

const KanbanColumn = forwardRef<KanbanColumnHandle, KanbanColumnProps>(
  (
    {
      etapa,
      filters,
      isShared,
      readOnly,
      isDragOver,
      isValidTarget,
      draggingLeadId,
      onDragOver,
      onDragLeave,
      onDrop,
      onDragStart,
      onDragEnd,
      onUpdateClick,
      onProdutoClick,
      onSubEtapaClick,
      showCorretorEquipe,
      cargoExibicao,
      onEtiquetaClick,
      onMenuClick,
      onWhatsAppClick,
      onWhatsAppCopyPhone,
      isWhatsConnected,
      getWhatsAppUnreadCount,
      onTotalCount,
      filtersKey,
    },
    ref
  ) => {
    const [state, dispatch] = useReducer(colReducer, {
      leads: [],
      page: 0,
      hasMore: true,
      loading: false,
    });
    const [totalItems, setTotalItems] = useState(0);
    const sentinelRef = useRef<HTMLDivElement | null>(null);
    const observerRef = useRef<IntersectionObserver | null>(null);
    const fetchingRef = useRef(false);
    const stateRef = useRef(state);
    stateRef.current = state;

    const url = isShared
      ? `${leadsWebEnviroment}/commom/leads/compartilhados/v2`
      : `${leadsWebEnviroment}/commom/leads/proprios/v2`;

    const fetchPage = useCallback(
      async (pageNum: number) => {
        if (fetchingRef.current) return;
        fetchingRef.current = true;
        dispatch({ type: "FETCH_START" });

        try {
          const base = buildFiltersBody(filters);
          delete base.Etapas;
          const body: any = {
            ...base,
            EtapaVisualizacao: etapa.id,
            PaginaAtual: pageNum,
            TotalItensRetorno: PAGE_SIZE,
            paginationParams: undefined,
            PalavrasChave: base.PalavrasChave,
          };
          Object.keys(body).forEach(
            (k) => body[k] === undefined && delete body[k]
          );

          const response = await instance.post(url, body);
          const leadsData: Lead[] =
            response?.data?.data?.leadsDataResponse ?? [];
          const pagination = response?.data?.pagination;
          const total: number = pagination?.totalItems ?? 0;
          const totalPages: number = pagination?.quantityPages ?? 1;

          if (pageNum === 1) {
            setTotalItems(total);
            onTotalCount?.(etapa.id, total);
          }

          dispatch({
            type: "FETCH_SUCCESS",
            leads: leadsData,
            page: pageNum,
            hasMore: pageNum < totalPages,
          });
        } catch {
          dispatch({
            type: "FETCH_SUCCESS",
            leads: [],
            page: pageNum,
            hasMore: false,
          });
        } finally {
          fetchingRef.current = false;
        }
      },
      [filtersKey, etapa.id, isShared]
    );

    // Expõe refresh() e patchLead() para o pai atualizar só esta coluna
    useImperativeHandle(ref, () => ({
      refresh: () => {
        dispatch({ type: "RESET" });
        fetchingRef.current = false;
        fetchPage(1);
      },
      patchLead: (idLeadCorretor: string, patch: Partial<Lead>) => {
        dispatch({ type: "PATCH_LEAD", idLeadCorretor, patch });
      },
    }));

    // Reset + fetch page 1 whenever filters or etapa changes
    useEffect(() => {
      dispatch({ type: "RESET" });
      fetchingRef.current = false;
      fetchPage(1);
    }, [filtersKey, etapa.id]);

    // IntersectionObserver — só recriado quando fetchPage muda
    useEffect(() => {
      if (observerRef.current) observerRef.current.disconnect();

      observerRef.current = new IntersectionObserver(
        (entries) => {
          if (
            entries[0].isIntersecting &&
            stateRef.current.hasMore &&
            !stateRef.current.loading
          ) {
            fetchPage(stateRef.current.page + 1);
          }
        },
        { threshold: 0.1 }
      );

      if (sentinelRef.current) {
        observerRef.current.observe(sentinelRef.current);
      }

      return () => observerRef.current?.disconnect();
    }, [fetchPage]);

    return (
      <S.Column
        isDragOver={isDragOver}
        isValidTarget={isValidTarget}
        onDragOver={onDragOver}
        onDragLeave={onDragLeave}
        onDrop={onDrop}
      >
        <S.ColumnHeader>
          <S.ColumnTitle title={etapa.nome}>{etapa.nome}</S.ColumnTitle>
          <S.ColumnCount>
            {state.loading && state.leads.length === 0 ? "…" : totalItems}
          </S.ColumnCount>
        </S.ColumnHeader>

        <S.ColumnCards isDragOver={isDragOver} isValidTarget={isValidTarget}>
          {state.loading && state.leads.length === 0 && (
            <div
              style={{ display: "flex", justifyContent: "center", padding: 16 }}
            >
              <CircularProgress size={20} style={{ color: "#2D5BFF" }} />
            </div>
          )}

          {isDragOver && isValidTarget && (
            <S.DropPlaceholder>Soltar aqui</S.DropPlaceholder>
          )}

          {!state.loading && state.leads.length === 0 && !isDragOver && (
            <S.EmptyColumn>Sem leads</S.EmptyColumn>
          )}

          {state.leads.map((lead) => (
            <KanbanCard
              key={lead.idLeadCorretor}
              lead={lead}
              isDragging={draggingLeadId === lead.idLeadCorretor}
              isShared={isShared}
              readOnly={readOnly}
              onDragStart={(e) => onDragStart(e, lead)}
              onDragEnd={onDragEnd}
              onUpdateClick={onUpdateClick}
              onProdutoClick={onProdutoClick}
              onSubEtapaClick={onSubEtapaClick}
              showCorretorEquipe={showCorretorEquipe}
              cargoExibicao={cargoExibicao}
              onEtiquetaClick={onEtiquetaClick}
              onMenuClick={onMenuClick}
              onWhatsAppClick={onWhatsAppClick}
              onWhatsAppCopyPhone={onWhatsAppCopyPhone}
              isWhatsConnected={isWhatsConnected}
              whatsAppUnreadCount={getWhatsAppUnreadCount?.(lead) || 0}
            />
          ))}

          <div ref={sentinelRef} style={{ height: 1 }} />

          {state.loading && state.leads.length > 0 && (
            <div
              style={{ display: "flex", justifyContent: "center", padding: 8 }}
            >
              <CircularProgress size={16} style={{ color: "#2D5BFF" }} />
            </div>
          )}
        </S.ColumnCards>
      </S.Column>
    );
  }
);
KanbanColumn.displayName = "KanbanColumn";

// Etapas que não aceitam drops manuais (só entrada automática via proposta)
// Etapas que nunca podem ser destino de um drag (não se pode voltar para elas)
const ETAPAS_BLOQUEADAS_DESTINO = ["Em Negociação", "Comprou", "Novo Lead"];

function canDrop(_fromEtapaNome: string, toEtapaNome: string): boolean {
  if (ETAPAS_BLOQUEADAS_DESTINO.includes(toEtapaNome)) return false;
  return true;
}

// ── KanbanView ─────────────────────────────────────────────────────────────────
export function KanbanView({
  filters,
  isShared,
  onMenuClick,
  onWhatsAppClick,
  onWhatsAppCopyPhone,
  isWhatsConnected,
  getWhatsAppUnreadCount,
}: KanbanViewProps) {
  const {
    data: etapasData,
    refetch: refetchEtapas,
    isLoading: isLoadingEtapas,
  } = useGetEtapas();

  const { data: tagsData } = getEtiquetas();

  const { codigoCargo2013, usuarioGerenteOnline } = useSelector<
    RootStateOrAny,
    AuthState
  >((state) => state.user);
  // Superintendente / Gerente Geral → mostra Corretor + Equipe
  const CARGOS_SUPER = ["219.840.000", "219.840.003"];
  // Gerente Vendas / Supervisor → mostra Corretor + Último responsável
  const CARGOS_GERENTE = ["219.840.001", "219.840.013", "219.840.005"];
  const cargoExibicao: "super" | "gerente" | null = CARGOS_SUPER.includes(
    codigoCargo2013 || ""
  )
    ? "super"
    : CARGOS_GERENTE.includes(codigoCargo2013 || "")
    ? "gerente"
    : null;
  const showCorretorEquipe = cargoExibicao !== null;

  // Build a stable key from filters — excludes pagination and Etapas (used only
  // by the list view) so the kanban only resets when real filters change.
  const filtersKey = (() => {
    const base = buildFiltersBody(filters);
    delete base.PaginaAtual;
    delete base.TotalItensRetorno;
    delete base.Etapas;
    return JSON.stringify(base);
  })();

  // EtapasModal state
  const [etapasOpen, setEtapasOpen] = useState(false);
  const [anchorLead, setAnchorLead] = useState("");
  const [anchorLeadCorretor, setAnchorLeadCorretor] = useState("");
  const [anchorEtapa, setAnchorEtapa] = useState({ label: "", value: "" });
  const [anchorSubEtapa, setAnchorSubEtapa] = useState({
    label: "",
    value: "",
  });
  const [targetEtapa, setTargetEtapa] = useState<EtapaOption | null>(null);

  // ProdutosModal state
  const [produtosOpen, setProdutosOpen] = useState(false);
  const [produtosLeadCorretor, setProdutosLeadCorretor] = useState("");
  const [produtosAtuais, setProdutosAtuais] = useState<
    Array<{ id: string; nome: string }>
  >([]);

  // AtualizarLeadModal state
  const [atualizarOpen, setAtualizarOpen] = useState(false);
  const [atualizarLeadId, setAtualizarLeadId] = useState("");

  // DnD state
  const [draggingLeadId, setDraggingLeadId] = useState<string | null>(null);
  const [dragOverColumnId, setDragOverColumnId] = useState<string | null>(null);
  const dragLeadRef = useRef<Lead | null>(null);

  // Refs por coluna — permite refresh seletivo sem recarregar todo o kanban
  const columnRefsMap = useRef<Map<string, KanbanColumnHandle>>(new Map());
  // Etapas afetadas pelo último drag (origem e destino)
  const affectedEtapasRef = useRef<string[]>([]);
  // Etapa e idLeadCorretor do lead sendo editado — usados para patch seletivo
  const editingLeadEtapaRef = useRef<string>("");
  const editingLeadCorretorRef = useRef<string>(""); // idLeadCorretor do lead em edição

  // EtiquetaMenu state
  const etiquetaAnchorRef = useRef<HTMLElement | null>(null);
  const [etiquetaMenuOpen, setEtiquetaMenuOpen] = useState(false);
  const [etiquetaLeadCorretor, setEtiquetaLeadCorretor] = useState("");

  useEffect(() => {
    refetchEtapas();
  }, []);

  const etapas: EtapaOption[] = Array.isArray(etapasData) ? etapasData : [];

  const handleDragStart = useCallback((e: React.DragEvent, lead: Lead) => {
    dragLeadRef.current = lead;
    setDraggingLeadId(lead.idLeadCorretor);
    e.dataTransfer.effectAllowed = "move";
  }, []);

  const handleDragEnd = useCallback(() => {
    setDraggingLeadId(null);
    setDragOverColumnId(null);
    dragLeadRef.current = null;
  }, []);

  const handleDragOver = useCallback((e: React.DragEvent, etapaId: string) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
    setDragOverColumnId(etapaId);
  }, []);

  const handleDragLeave = useCallback((e: React.DragEvent) => {
    const related = e.relatedTarget as HTMLElement | null;
    const currentTarget = e.currentTarget as HTMLElement;
    if (!related || !currentTarget.contains(related)) {
      setDragOverColumnId(null);
    }
  }, []);

  const handleDrop = useCallback((e: React.DragEvent, etapa: EtapaOption) => {
    e.preventDefault();
    const lead = dragLeadRef.current;
    if (!lead) return;
    if (
      lead.idEtapaFunil === etapa.id ||
      !canDrop(lead.etapaFunil, etapa.nome)
    ) {
      setDraggingLeadId(null);
      setDragOverColumnId(null);
      dragLeadRef.current = null;
      return;
    }
    setAnchorLead(lead.idLead);
    setAnchorLeadCorretor(lead.idLeadCorretor);
    setAnchorEtapa({ label: lead.etapaFunil, value: lead.idEtapaFunil });
    setAnchorSubEtapa({
      label: lead.subEtapaFunil,
      value: lead.idSubEtapaFunil,
    });
    setTargetEtapa(etapa);
    setEtapasOpen(true);
    setDraggingLeadId(null);
    setDragOverColumnId(null);
    // Guarda as duas colunas afetadas para refresh seletivo
    affectedEtapasRef.current = [lead.idEtapaFunil, etapa.id];
    dragLeadRef.current = null;
  }, []);

  const patchLeadEtapa = useCallback((patch: Partial<Lead>) => {
    const etapaId = editingLeadEtapaRef.current;
    const idLeadCorretor = editingLeadCorretorRef.current;
    if (etapaId && idLeadCorretor) {
      columnRefsMap.current.get(etapaId)?.patchLead(idLeadCorretor, patch);
    }
  }, []);

  const handleUpdateClick = useCallback((lead: Lead) => {
    editingLeadEtapaRef.current = lead.idEtapaFunil;
    editingLeadCorretorRef.current = lead.idLeadCorretor;
    setAtualizarLeadId(lead.idLead);
    setAtualizarOpen(true);
  }, []);

  const handleProdutoClick = useCallback((lead: Lead) => {
    editingLeadEtapaRef.current = lead.idEtapaFunil;
    editingLeadCorretorRef.current = lead.idLeadCorretor;
    setProdutosLeadCorretor(lead.idLeadCorretor);
    setProdutosAtuais(
      Array.isArray(lead.empreendimentos)
        ? lead.empreendimentos.map((e: any) => ({ id: e.id, nome: e.nome }))
        : []
    );
    setProdutosOpen(true);
  }, []);

  const handleSubEtapaClick = useCallback((lead: Lead) => {
    editingLeadEtapaRef.current = lead.idEtapaFunil;
    editingLeadCorretorRef.current = lead.idLeadCorretor;
    setAnchorLead(lead.idLead);
    setAnchorLeadCorretor(lead.idLeadCorretor);
    setAnchorEtapa({ label: lead.etapaFunil, value: lead.idEtapaFunil });
    setAnchorSubEtapa({
      label: lead.subEtapaFunil || "",
      value: lead.idSubEtapaFunil || "",
    });
    setTargetEtapa({ id: lead.idEtapaFunil, nome: lead.etapaFunil });
    affectedEtapasRef.current = [lead.idEtapaFunil];
    setEtapasOpen(true);
  }, []);

  const handleEtiquetaClick = useCallback((e: React.MouseEvent, lead: Lead) => {
    etiquetaAnchorRef.current = e.currentTarget as HTMLElement;
    editingLeadEtapaRef.current = lead.idEtapaFunil;
    editingLeadCorretorRef.current = lead.idLeadCorretor;
    setEtiquetaLeadCorretor(lead.idLeadCorretor);
    setEtiquetaMenuOpen(true);
  }, []);

  const handleAlterarEtiqueta = useCallback(
    (idEtiqueta: string) => {
      const etiqueta =
        tagsData?.etiquetasCorretor?.find((t: any) => t.id === idEtiqueta) ??
        null;
      postEtiquetaLead({ idLeadCorretor: etiquetaLeadCorretor, idEtiqueta })
        .then(({ success, data }: any) => {
          if (success) {
            toast.success(data);
            patchLeadEtapa({ etiqueta });
          } else {
            throw new Error();
          }
        })
        .catch(() => toast.error("Erro ao alterar etiqueta"));
      setEtiquetaMenuOpen(false);
    },
    [etiquetaLeadCorretor, patchLeadEtapa, tagsData]
  );

  if (isLoadingEtapas) {
    return (
      <S.LoadingContainer>
        <CircularProgress size={32} style={{ color: "#2D5BFF" }} />
      </S.LoadingContainer>
    );
  }

  if (!etapas || etapas.length === 0) {
    return (
      <S.LoadingContainer>
        <span style={{ color: "#aaa", fontFamily: "Inter", fontSize: 14 }}>
          Nenhuma etapa encontrada
        </span>
      </S.LoadingContainer>
    );
  }

  return (
    <>
      <S.BoardContainer>
        {etapas.map((etapa) => {
          const isDragOver = dragOverColumnId === etapa.id;
          const draggingLead = dragLeadRef.current;
          const isValidTarget =
            !!draggingLeadId &&
            !!draggingLead &&
            draggingLead.idEtapaFunil !== etapa.id &&
            canDrop(draggingLead.etapaFunil, etapa.nome);

          return (
            <KanbanColumn
              key={etapa.id}
              ref={(handle) => {
                if (handle) {
                  columnRefsMap.current.set(etapa.id, handle);
                } else {
                  columnRefsMap.current.delete(etapa.id);
                }
              }}
              etapa={etapa}
              filters={filters}
              isShared={isShared}
              readOnly={usuarioGerenteOnline}
              filtersKey={filtersKey}
              isDragOver={isDragOver}
              isValidTarget={isValidTarget}
              draggingLeadId={draggingLeadId}
              onDragOver={(e) => handleDragOver(e, etapa.id)}
              onProdutoClick={handleProdutoClick}
              onSubEtapaClick={handleSubEtapaClick}
              showCorretorEquipe={showCorretorEquipe}
              cargoExibicao={cargoExibicao}
              onEtiquetaClick={handleEtiquetaClick}
              onDragLeave={handleDragLeave}
              onDrop={(e) => handleDrop(e, etapa)}
              onDragStart={handleDragStart}
              onDragEnd={handleDragEnd}
              onUpdateClick={handleUpdateClick}
              onMenuClick={onMenuClick}
              onWhatsAppClick={onWhatsAppClick || (() => {})}
              onWhatsAppCopyPhone={onWhatsAppCopyPhone}
              isWhatsConnected={isWhatsConnected}
              getWhatsAppUnreadCount={getWhatsAppUnreadCount}
            />
          );
        })}
      </S.BoardContainer>

      {/* Atualizar Etapa modal */}
      <DialogCommon
        closeText="Fechar"
        saveText="Salvar"
        onClose={() => setEtapasOpen(false)}
        onSave={() => {}}
        isRight={false}
        onClean={() => {}}
        titleHeader="Atualizar etapa"
        isFilter={false}
        isClose
        width={400}
        component={
          <EtapasModal
            onClose={() => setEtapasOpen(false)}
            open={etapasOpen}
            anchorLeadCorretor={anchorLeadCorretor}
            anchorLead={anchorLead}
            anchorEtapa={
              targetEtapa
                ? { label: targetEtapa.nome, value: targetEtapa.id }
                : anchorEtapa
            }
            anchorSubEtapa={
              targetEtapa ? { label: "", value: "" } : anchorSubEtapa
            }
            hideEtapa={!!targetEtapa}
            refetch={() => {
              // Atualiza apenas as colunas afetadas pelo drag (origem e destino)
              affectedEtapasRef.current.forEach((etapaId) => {
                columnRefsMap.current.get(etapaId)?.refresh();
              });
              affectedEtapasRef.current = [];
            }}
          />
        }
        setOpenModal={setEtapasOpen}
        open={etapasOpen}
        icon={<EtapaIcon />}
      />

      {/* Alterar Produtos modal */}
      <DialogCommon
        closeText="Fechar"
        saveText="Salvar"
        onClose={() => setProdutosOpen(false)}
        onSave={() => {}}
        isRight={false}
        onClean={() => {}}
        titleHeader="Alterar produtos"
        isFilter={false}
        isClose
        width={500}
        component={
          <ProdutosModal
            onClose={() => setProdutosOpen(false)}
            open={produtosOpen}
            anchorLeadCorretor={produtosLeadCorretor}
            produtosAtuais={produtosAtuais}
            refetch={(responseData?: any) => {
              if (responseData?.empreendimentos) {
                patchLeadEtapa({
                  empreendimentos: responseData.empreendimentos,
                });
              }
            }}
          />
        }
        setOpenModal={setProdutosOpen}
        open={produtosOpen}
        icon={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#D1FADF",
              border: "8px solid #ECFDF3",
              padding: 2,
              borderRadius: "50%",
              height: 52,
              width: 52,
              marginRight: 12,
            }}
          >
            <RiBuilding2Fill color="black" size={24} style={{ margin: 0 }} />
          </div>
        }
      />

      {/* Menu de etiquetas */}
      <Menu
        anchorEl={etiquetaAnchorRef.current}
        open={etiquetaMenuOpen}
        onClose={() => setEtiquetaMenuOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <MenuItem
          onClick={() => handleAlterarEtiqueta("")}
          style={{ fontSize: 12 }}
        >
          <p
            style={{
              padding: "2px 6px",
              color: "black",
              fontSize: 12,
              borderRadius: 8,
              margin: 0,
            }}
          >
            Sem etiqueta
          </p>
        </MenuItem>
        {tagsData?.etiquetasCorretor?.map(
          (item: { id: string; nome: string; cor: string }) => (
            <MenuItem
              key={item.id}
              onClick={() => handleAlterarEtiqueta(item.id)}
              style={{ fontSize: 12 }}
            >
              <Tooltip title={item.nome} placement="right" arrow>
                <p
                  style={{
                    padding: "2px 8px",
                    backgroundColor: item.cor ?? "gray",
                    color: "white",
                    fontSize: 12,
                    borderRadius: 8,
                    margin: 0,
                    maxWidth: 120,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {item.nome}
                </p>
              </Tooltip>
            </MenuItem>
          )
        )}
      </Menu>

      {/* Atualizar Lead modal */}
      <AtualizarLeadModal
        open={atualizarOpen}
        onClose={() => setAtualizarOpen(false)}
        idLead365={atualizarLeadId}
        onSuccess={(responseData?: any) => {
          if (responseData) {
            patchLeadEtapa({
              farolAtualizacao: responseData.farolAtualizacao,
              dataUltimaAtualizacao: responseData.dataUltimaAtualizacao,
            });
          }
        }}
      />
    </>
  );
}
